import { produce } from 'immer';
import { queryKeyFn } from '../../generated/sitContext';
import { produceCallback } from '../produce-callback';
import { modifyExistingQueryData } from '../query';
import { getTimesheetFromTimesheetsQueryData, setTimesheetsQueryData, } from '../timesheets/query';
export function getTimesheetQueryKey(id) {
    return queryKeyFn({
        path: '/timesheets/{id}',
        operationId: 'getApiTimesheetsByUuid',
        variables: {
            pathParams: {
                id,
            },
        },
    });
}
export function invalidateTimesheetQuery(queryClient, id) {
    return queryClient.invalidateQueries({ queryKey: getTimesheetQueryKey(id) });
}
export function getTimesheetQueryData(queryClient, id) {
    const tsQd = queryClient.getQueryData(getTimesheetQueryKey(id));
    return tsQd ? tsQd : getTimesheetFromTimesheetsQueryData(queryClient, id);
}
export const setTimesheetQueryData = (queryClient, id, updater) => {
    modifyExistingQueryData(queryClient, getTimesheetQueryKey(id), produceCallback(updater));
    // We also update the query data for get timesheets
    setTimesheetsQueryData(queryClient, (old) => {
        if (!old)
            return old;
        return produce(old, (draft) => {
            const timesheet = draft.find((timesheet) => timesheet.id === id);
            if (!timesheet)
                return draft;
            updater(timesheet);
            return draft;
        });
    });
};
//# sourceMappingURL=query.js.map